/**
 * Contract Bridge — rules options (docs/rules/bridge.md §5.2).
 *
 * The rules of the auction and the play are not options; the only choices a
 * casual single table makes are how many boards it plays and how vulnerability
 * rotates. Scoring is duplicate-style per board, summed (rules §2.7–2.8).
 */
export const DEFAULT_BRIDGE_CONFIG = { boards: 4, vulnerability: 'chicago' };
export const BRIDGE_TRICKS_PER_HAND = 13;
export function validateBridgeConfig(raw) {
    if (raw === undefined || raw === null)
        return { ok: true, config: DEFAULT_BRIDGE_CONFIG };
    if (typeof raw !== 'object')
        return { ok: false, error: 'config must be an object' };
    const r = raw;
    const out = { ...DEFAULT_BRIDGE_CONFIG };
    const errors = [];
    if (r.boards !== undefined) {
        const v = r.boards;
        if (typeof v !== 'number' || !Number.isInteger(v) || v < 1 || v > 32)
            errors.push('boards must be an integer in [1, 32]');
        else
            out.boards = v;
    }
    if (r.vulnerability !== undefined) {
        if (r.vulnerability !== 'chicago' && r.vulnerability !== 'duplicate') {
            errors.push("vulnerability must be one of 'chicago' | 'duplicate'");
        }
        else
            out.vulnerability = r.vulnerability;
    }
    if (errors.length > 0)
        return { ok: false, error: errors.join('; ') };
    return { ok: true, config: out };
}
//# sourceMappingURL=config.js.map